import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

// Shown once, the moment the user chooses to open a live/approved PR for edit -- opening the
// form itself never changes anything; only an actual save on confirm does. Message adapts by
// current PR status: a fresh approval_in_progress cycle vs. an already-approved PR.
const EditPRConfirmDialog = ({ open, onClose, onConfirm, prStatus }) => {
  const isApproved = prStatus === "approved";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" sx={{borderRadius:"25px"}}>
      <DialogTitle>Edit Purchase Requisition</DialogTitle>
      <DialogContent>
        <ul>
          <li>
            <Typography variant="body2" sx={{ mb: 1 }}>
            Opening this form will not affect the current approval.
            </Typography>
          </li>
          <li>
            <Typography variant="body2">
              {isApproved
                ? "This Purchase Requisition is already approved. Saving any changes will restart approval from stage one — resubmission is required to send it for approval again."
                : "Saving any changes here will stop the existing approval cycle. Resubmission will restart approval from stage one."}
            </Typography>
          </li>
          <li>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Earlier approval history is kept and will remain visible.
            </Typography>
          </li>
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="warning" onClick={onConfirm}>
          Continue to Edit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditPRConfirmDialog;
